module.exports = __webpack_public_path__ + "media/images/session/session-b698eeda61101c9241f486b22bb8a936.jpg";